import React, { useContext, useEffect, useRef, useState } from "react";
import RequestCard from "../../components/ui/RequestCard";
import CustomDropDown from "../../components/ui/CustomDropDown";
import { Typography } from "@mui/material";
import { ReactComponent as KeyArrowUpIcon } from "../../assets/icons/stock_icons/KeyArrowUpIcon.svg";
import { ReactComponent as KeyArrowDownIcon } from "../../assets/icons/stock_icons/KeyArrowDownIcon.svg";
import apiClient from "../../lib/api_client";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import RequestCardSkeleton from "../../components/ui/skeletons/RequestCardSkeleton";
import { formatTrayName } from "../../utils/formatTrayName";
import { SocketContext } from "../../context/SocketContext";
import { useLocation } from "react-router-dom";
import notificationSound from "../../assets/notification/noti.wav";

const RequestSection = () => {
  const menuOptions = [
    "Requests Pending",
    "Completed Requests",
    "Cancelled Requests",
  ];
  const [selectedMenu, setSelectedMenu] = useState(menuOptions[0]);
  const [anchorEl, setAnchorEl] = useState(null);

  const playSoundOnNextUpdate = useRef(false);
  const prevDataLength = useRef(0);

  const socket = useContext(SocketContext);
  const queryClient = useQueryClient();
  const location = useLocation();
  const open = Boolean(anchorEl);
  const handleMenuItemClick = (menuItem) => {
    setSelectedMenu(menuItem);
    setAnchorEl(null);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Get Request
  const getRequests = async () => {
    let requestStatus;
    switch (selectedMenu) {
      case "Requests Pending":
        requestStatus = "Pending";
        break;
      case "Completed Requests":
        requestStatus = "Completed";
        break;
      case "Cancelled Requests":
        requestStatus = "Cancelled";
        break;
      default:
        requestStatus = "Pending";
    }
    try {
      const response = await apiClient.get(
        `/getRequests?requestStatus=${requestStatus}`
      );
      return response?.data?.data ?? []; // ✅ Fix 1: undefined ki jagah empty array
    } catch (error) {
      console.error("Error fetching requests:", error);
      throw new Error("Failed to fetch requests");
    }
  };

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["getRequests", selectedMenu],
    queryFn: getRequests,
  });

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const options = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    const time = date.toLocaleTimeString("en-US", options);
    return time;
  };

  const formatDate = (dateString) => {
    function getDayWithSuffix(day) {
      if (day > 3 && day < 21) return day + "th";
      switch (day % 10) {
        case 1:
          return day + "st";
        case 2:
          return day + "nd";
        case 3:
          return day + "rd";
        default:
          return day + "th";
      }
    }
    const date = new Date(dateString);
    const options = { timeZone: "Asia/Kolkata" };
    const localDate = new Date(date.toLocaleString("en-US", options));
    const day = localDate.getDate();
    const dayWithSuffix = getDayWithSuffix(day);
    const month = localDate.toLocaleString("en-US", { month: "short" });
    const year = localDate.getFullYear();
    const time = localDate.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return `${dayWithSuffix} ${month} ${year}, ${time}`;
  };

  function getTimeDifference(start, end) {
    const startDate = new Date(start);
    const endDate = new Date(end);
    let diffMs = Math.abs(endDate - startDate);
    const hours = String(Math.floor(diffMs / (1000 * 60 * 60))).padStart(
      2,
      "0"
    );
    diffMs %= 1000 * 60 * 60;
    const minutes = String(Math.floor(diffMs / (1000 * 60))).padStart(2, "0");
    diffMs %= 1000 * 60;
    const seconds = String(Math.floor(diffMs / 1000)).padStart(2, "0");
    return `${hours}h:${minutes}m:${seconds}s`;
  }

  useEffect(() => {
    if (!Array.isArray(data)) return;

    const hasNewData = data.length > prevDataLength.current;

    if (playSoundOnNextUpdate.current && hasNewData) {
      
      const audio = new Audio(notificationSound);
      audio.play().catch((err) => console.error("Sound error:", err));
      playSoundOnNextUpdate.current = false;
    }

    prevDataLength.current = data.length;
  }, [data]);

  useEffect(() => {
    const path = location?.pathname;
    if (path === "/stock" || path === "/Stock") {
      socket.on("select-submit-request-and-collect-message", (socketData) => {
        if (socketData?.refetch) {
         
          playSoundOnNextUpdate.current = true;
          // ✅ Fix 2: sahi query key — space wali string hata di
          queryClient.invalidateQueries({ queryKey: ["getRequests", selectedMenu] });
          refetch();
        }
      });
    }
    return () => {
      socket.off("select-submit-request-and-collect-message");
    };
  }, []);

  return (
    <>
      <span
        onClick={handleClick}
        style={{
          display: "inline-block",
          width: "fit-content",
          height: "7vh",
          padding: ".75vw  0.75vw",
          paddingBottom: 0,
        }}
      >
        <Typography
          sx={{
            cursor: "pointer",
            fontWeight: 400,
            fontSize: "1.2vw",
            display: "flex",
            alignItems: "center",
            fontFamily: "Poppins",
            color: "#fff",
          }}
        >
          {selectedMenu}
          <span
            style={{ marginLeft: "0.25vw", fontWeight: 400, fontSize: "1.2vw" }}
          >
            {" - " + (Array.isArray(data) ? data.length : 0)}
          </span>
          {open ? (
            <KeyArrowUpIcon style={{ marginLeft: "0.5vw" }} />
          ) : (
            <KeyArrowDownIcon style={{ marginLeft: "0.5vw" }} />
          )}
        </Typography>
      </span>
      <CustomDropDown
        anchorEl={anchorEl}
        open={open}
        handleClose={() => setAnchorEl(null)}
        options={menuOptions}
        onSelect={handleMenuItemClick}
        style={{
          width: "fit-content",
          height: "fit-content",
          fontSize: "1.1vw",
        }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1vw",
          background: "#000000",
          width: "100%",
          height: "78vh",
          flexGrow: 1,
          padding: ".75vw  0.75vw",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        {isLoading ? (
          <>
            <RequestCardSkeleton />
            <RequestCardSkeleton />
            <RequestCardSkeleton />
          </>
        ) : (
          data
            ?.reverse()
            .map((el) => (
              <RequestCard
                key={el._id}
                id={el._id}
                type={el.requestType}
                requestId={el.requestId}
                requestTime={formatTime(el.createTime)}
                trayName={formatTrayName(el.trayName)}
                clientName={el.clientName}
                salesPersonName={el.salesPersonName}
                purchaseNo={el.purchaseNo}
                status={el.requestStatus}
                responseTime={getTimeDifference(
                  el?.createTime,
                  el?.requestCompletedTime
                )}
                message={el?.cancelRequestMessage}
                isOccupied={el?.isOccupied}
                requestCompletedTime={formatDate(el?.requestCompletedTime)}
                refetch={refetch}
              />
            ))
        )}
      </div>
    </>
  );
};

export default RequestSection;
